import { put, call, getContext } from "redux-saga/effects";

import { invoiceList } from "../../Services/ClaimCashless";

export function* invoiceListSaga(action) {
  const store = yield getContext("store");

  const { payload } = action;
  try {
    const res = yield call(
      invoiceList,
      payload

      //   (percent) => {
      //     store.dispatch({
      //       type: "REQ_INVOICE_LIST_PROGRESS",
      //       progress: percent,
      //     });
      //   }
    );

    yield put({ type: "REQ_INVOICE_LIST_SUCCESS", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_INVOICE_LIST_FAILED", errData: e });
  }
}
